import React from "react";
import { Link } from "react-router-dom";
import icon01 from "../assests/img/icon-01.png";
import icon02 from "../assests/img/icon-02.png";
import icon03 from "../assests/img/icon-03.png";
import icon04 from "../assests/img/icon-04.png";
import icon05 from "../assests/img/icon-05.png";
import icon06 from "../assests/img/icon-06.png";
import icon07 from "../assests/img/icon-07.png";
import icon08 from "../assests/img/icon-08.png";

const addOnServices = [
  { name: "Photography Sets", icon: icon01 },
  { name: "Cinematography Sets", icon: icon02 },
  { name: "Make Up Room", icon: icon03 },
  { name: "Cafeteria", icon: icon04 },
  { name: "Props", icon: icon05 },
  { name: "On-Site Support Staff", icon: icon06 },
  { name: "Parking", icon: icon07 },
  { name: "Lights & Equipment", icon: icon08 },
];

function Latestproduct() {
  return (
    <section className="addon-services-section" id="addon-services-section">
      <div className="addon-services-overlay">
        <div className="container">
            <div className="our-sets-heading">
          <span>Picture Valley</span>
          <h2>Add on services</h2>
        </div>

          <div className="addon-services-grid">
            {addOnServices.map((service) => (
              <div className="addon-service-item" key={service.name}>
                <div className="addon-service-icon">
                  <img src={service.icon} alt={service.name} />
                </div>              
              </div>
            ))}
          </div>

          <Link to="/contact" className="addon-services-btn btn">
            Book Now
          </Link>
        </div>
      </div>
    </section>
  );
}

export default Latestproduct;
